import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextTooltipDirective } from '../../directives/TextTooltip.directive';

// Palette Tailwind d'origine : fond 100, bordure 600, texte 800.
const TOOLTIP_THEMES = {
  content:     { fond: '#DCFCE7', texte: '#166534', bordure: '2px solid #16A34A' },
  indifferent: { fond: '#FFEDD5', texte: '#9A3412', bordure: '2px solid #EA580C' },
  mecontent:   { fond: '#FEE2E2', texte: '#991B1B', bordure: '2px solid #DC2626' },
} as const;

@Component({
  selector: 'app-bubble-smiley',
  standalone: true,
  imports: [CommonModule, TextTooltipDirective],
  templateUrl: './bubble-smiley.component.html'
})
export class BubbleSmileyComponent {
  @Input({ required: true }) score!: number;   // 1=Content, 2=Indifférent, 3=Mécontent
  @Input() showAsBubble = true;                  // true: bulle ovale, false: smiley rond
  @Input() comment = '';                         // Texte du commentaire
  @Input() showCommentInTooltip = false;         // Tooltip au survol
  @Input() size = 'w-16 h-16';                   // classe Tailwind (ex: w-16 h-16)
  @Input() showAsSelected = false;               // Coche verte en haut à droite

  get emotionType(): 'content' | 'indifferent' | 'mecontent' {
    switch (this.score) {
      case 1: return 'content';
      case 2: return 'indifferent';
      case 3: return 'mecontent';
      default: return 'indifferent';
    }
  }

  get tooltipTheme() {
    return TOOLTIP_THEMES[this.emotionType];
  }
}
